import React from 'react'
import Button from './Button'
import Icon from '../Icon/Icon'
import { Content, IconContainer } from './IconButton.styles'

export default (props) => (
  <Button {...props}>
    <IconContainer size={props.size}>
      <Icon {...props} name={props.iconName} />
    </IconContainer>
    <Content size={props.size}>{props.children}</Content>
  </Button>
)
